import * as Yup from 'yup';

export const tenantValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Razão social é obrigatória')
    .min(3, 'Razão social deve ter no mínimo 3 caracteres')
    .max(255, 'Razão social deve ter no máximo 255 caracteres'),
  
  fantasyName: Yup.string()
    .required('Nome fantasia é obrigatório')
    .min(3, 'Nome fantasia deve ter no mínimo 3 caracteres')
    .max(255, 'Nome fantasia deve ter no máximo 255 caracteres'),

  corporateName: Yup.string()
    .required('Razão social é obrigatório')
    .min(3, 'Razão social deve ter no mínimo 3 caracteres')
    .max(255, 'Razão social deve ter no máximo 255 caracteres'),
  
  documentNumber: Yup.string()
    .required('CNPJ é obrigatório')
    .matches(
      /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$|^\d{14}$/,
      'CNPJ deve estar no formato XX.XXX.XXX/XXXX-XX ou ter 14 dígitos'
    ),
  
  email: Yup.string()
    .email('E-mail inválido')
    .max(255, 'E-mail deve ter no máximo 255 caracteres')
    .optional(),
  
    phoneNumber: Yup.string()
    .matches(
      /^(\(?\d{2}\)?\s?)?(9\d{4}-?\d{4}|\d{4}-?\d{4})$/,
      'Telefone deve estar no formato (99) 99999-9999 ou (99) 9999-9999'
    )
    .optional(),
  
  site: Yup.string()
    .url('Site deve ser uma URL válida')
    .optional(),
  
  zipCode: Yup.string()
    .matches(/^\d{5}-\d{3}$|^\d{8}$/, 'CEP deve estar no formato XXXXX-XXX ou ter 8 dígitos')
    .optional(),
  
  street: Yup.string()
    .optional()
    .min(3, 'Rua deve ter no mínimo 3 caracteres')
    .max(255, 'Rua deve ter no máximo 255 caracteres'),
  
  streetNumber: Yup.string()
    .optional()
    .max(10, 'Número deve ter no máximo 10 caracteres'),
  
  complement: Yup.string()
    .max(255, 'Complemento deve ter no máximo 255 caracteres')
    .optional(),
  
  district: Yup.string()
    .optional()
    .min(3, 'Bairro deve ter no mínimo 3 caracteres')
    .max(255, 'Bairro deve ter no máximo 255 caracteres'),
  
  stateRegistration: Yup.string()
    .max(20, 'Inscrição estadual deve ter no máximo 20 caracteres')
    .optional(),
  
  municipalRegistration: Yup.string()
    .max(20, 'Inscrição municipal deve ter no máximo 20 caracteres')
    .optional(),
  
  typeId: Yup.string()
    .required('Segmento é obrigatório'),
  
  status: Yup.string()
    .required('Status é obrigatório'),
  
  stateId: Yup.string()
    .optional(),
  
  cityId: Yup.string()
    .optional(),
  
  description: Yup.string()
    .max(1000, 'Descrição deve ter no máximo 1000 caracteres')
    .optional(),
}).test('phone-validation', 'Telefone', function(values) {
  return true;
});